import { Dialog } from "primereact/dialog";
import { useEffect, useState, useRef } from "react";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { MultiSelect } from "primereact/multiselect";
import { Fetch } from "../../../../shared/Fetch";
import { IQuestion } from "../trainingQuestions/Table";

interface IProps {
    open: boolean,
    topic_ID: number | null,
    hideDialog: () => void,
    toast: any,
}

export const QuestionLink = (props: IProps) => {
    const [selectedQuestions, setSelectedQuestions] = useState<Array<IQuestion>>([]);
    const [allQuestions, setAllQuestions] = useState<Array<IQuestion>>([]);
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: IQuestion[], loading: boolean });

    const loadQuestions = async () => {
        const res = await Fetch("CarnivalTraining/getActiveQuestions12", "GET", null, `topic_ID=${props.topic_ID}`, props.toast);
        if (res) {
            const data: IQuestion[] = await res.json();
            setAllQuestions(data);
        }
    };

    const loadAddedQuestions = async () => {
        if (!props.topic_ID) return;

        const res = await Fetch("CarnivalTraining/getTopicQuestions", "GET", null, `topic_ID=${props.topic_ID}`, props.toast);
        if (res) {
            const data = await res.json();
            setTableData({ tableData: data, loading: false });
            setSelectedQuestions([]);
        }
    };


    const onSubmit = async () => {
        if (!props.topic_ID) return;

        const body: any = {
            topic_ID: props.topic_ID,
            question_IDs: selectedQuestions,
        };

        const res = await Fetch("CarnivalTraining/addTopicQuestions", "POST", body, null, props.toast);
        if (res) {
            props.toast.current.show({ severity: 'success', detail: "Saved", life: 3000 });
            loadAddedQuestions().then(() => loadQuestions());
        }
    };

    const deleteQuestion = async (row: any) => {
        const res = await Fetch("CarnivalTraining/removeTopicQuestion", "DELETE", null, `link_ID=${row.link_ID}`, props.toast);

        if (res) {
            props.toast.current.show({ severity: "success", detail: "Deleted", life: 2000 });

            await loadAddedQuestions();
            await loadQuestions();
        }
    };

    const actionBody = (row: IQuestion) => (
        <Button icon="pi pi-trash" className="p-button-danger" onClick={() => deleteQuestion(row)} />
    );

    const status = (row: IQuestion) => {
        return <p className="" style={{ color: (row.question_Status === true ? "green" : "red") }}>{row.question_Status === true ? "Active" : "Inactive"}</p>
    }

    const onHide = () => {
        setSelectedQuestions([]);
        setTableData({ tableData: [], loading: false });
        props.hideDialog();
    }

    useEffect(() => {
        if (props.open) {
            setSelectedQuestions([]);
            loadAddedQuestions().then(() => loadQuestions());
        }
    }, [props.open]);


    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Select Question" modal onHide={() => onHide()}>

            <MultiSelect value={selectedQuestions} onChange={(e) => setSelectedQuestions(e.value)} options={allQuestions} optionValue="question_ID" optionLabel="question" display="chip" filter placeholder="Select Questions" className="w-11" />

            <div className="flex justify-content-end gap-3 mt-3">
                <Button label="SAVE" onClick={onSubmit} className="p-button-success" />
                <Button label="CLOSE" onClick={props.hideDialog} className="p-button-outlined" />
            </div>

            <DataTable value={tableData.tableData} loading={tableData.loading} className="mt-4" header="Linked questions">
                <Column header="SN." body={(data, options) => options.rowIndex + 1} />
                <Column field="question" header="question" />
                <Column field="question_Status" header="Status" body={status} />
                <Column header="Action" body={actionBody} />
            </DataTable>
        </Dialog>
    );
}
